import React, { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  ICON_PREV_ALT,
  ICON_NEXT_ALT,
  ICON_LAST_PAGE,
  ICON_FIRST_PAGE,
} from "../../../extras/icons";

import clienteAxios from "../../../../config/axiosSae";

import ActuationView from "./ActuationView";
import { ErrorMessage, WaitingMessage } from "../../../extras/toastMessages";
import { ICON_SEARCH } from "../../../extras/icons";
import {
  MSG_ERROR_SERVER,
  MSG_LOADING_INFORMATION,
} from "../../../../constants/messages";

const ActuationsList = (props) => {
  // ============================================================================================
  // DECLARACIONES ------------------------------------------------------------------------------
  // ============================================================================================

  //Tomo los props
  const { audience } = props;

  // Inicializo el state local
  const [actuations, setActuations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedActuation, setSelectedActuation] = useState(null);
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(0);
  const [isLast, setIsLast] = useState(false);
  const [isFirst, setIsFirst] = useState(true);
  const [totalPages, setTotalPages] = useState(0);

  // ============================================================================================
  // FUNCIONES ----------------------------------------------------------------------------------
  // ============================================================================================

  // Manejo el cierre
  const handleClose = () => {
    setShow(false);
  };

  const handleNext = () => {
    if (!isLast && !loading) {
      setPage(page + 1);
    }
    return;
  };

  const handlePrev = () => {
    if (!isFirst && !loading) {
      setPage(page - 1);
    }
    return;
  };

  const handleLast = () => {
    if (!isLast && !loading) {
      setPage(totalPages - 1);
    }
    return;
  };

  const handleFirst = () => {
    if (!isFirst && !loading) {
      setPage(0);
    }
    return;
  };

  // Función para ver texto
  const handleView = async (actuation) => {
    // Verifico los datos
    if (actuation && actuation.id) {
      // Busco la actuación
      try {
        // Pongo espera
        WaitingMessage(MSG_LOADING_INFORMATION);
        // Consulta
        const response = await clienteAxios.get(`historia/dto/${actuation.id}`);
        // Asigno los datos
        setSelectedActuation(response.data);
        // Oculto espera
        Swal.close();
        // Muestro el diálogo
        setTimeout(() => {
          setShow(true);
        }, 500);
      } catch (error) {
        const response = error.response;
        let data = {
          data: null,
          message: MSG_ERROR_SERVER,
        };
        // Verifico si hay error
        if (response) {
          data = response.data;
        }
        // Oculto espera
        Swal.close();
        // Mensaje de error
        setTimeout(() => {
          ErrorMessage(data.message);
        }, 500);
      }
    }
  };

  // Busco las actuaciones del SAE
  const loadActuations = async () => {
    if (audience && audience.expediente && audience.expediente.procid) {
      try {
        // Pongo espera
        setLoading(true);
        // Consulta
        const response = await clienteAxios.get(
          `historia/dto?search=procesoSae.id:${audience.expediente.procid}&paging=${page},10&sort=fefi:desc`
        );
        // Asigno los datos
        setActuations(response.data.content);
        setTotalPages(response.data.totalPages);
        setIsFirst(response.data.first);
        setIsLast(response.data.last);
        setPage(response.data.pageable.pageNumber);
        // Oculto espera
        setLoading(false);
      } catch (error) {
        const response = error.response;
        let data = {
          data: null,
          message: "Error al conectarse al servidor",
        };
        // Verifico si hay error
        if (response) {
          data = response.data;
        }
        // Oculto espera
        setLoading(false);
        // Mensaje de error
        ErrorMessage(data.message);
      }
    } else {
      // Limpio los datos
      setActuations([]);
    }
  };

  useEffect(() => {
    // Si hay datos
    if (audience) {
      // Cargo actuaciones
      loadActuations();
    }
    //eslint-disable-next-line
  }, [audience, page]);

  // ============================================================================================
  // RENDERIZO ----------------------------------------------------------------------------------
  // ============================================================================================

  return (
    <div className="col-12">
      <div className="card shadow mb-4">
        <div className="card-header py-2 d-flex flex-row justify-content-between align-items-center   ">
          <h6 className="m-0 font-weight-bold text-primary">
            ACTUACIONES: SAE
          </h6>
          {totalPages > 1 && (
            <div>
              {!isFirst && (
                <Button
                  disabled={loading}
                  className="btn-circle ml-2 mr-2"
                  variant="outline-primary"
                  onClick={handleFirst}
                >
                  <ICON_FIRST_PAGE />
                </Button>
              )}
              {!isFirst ? (
                <Button
                  disabled={loading}
                  className="btn-circle mr-2"
                  variant="primary"
                  onClick={handlePrev}
                >
                  <ICON_PREV_ALT />
                </Button>
              ) : null}
              <Button variant="primary" disabled={true}>
                {page + 1} de {totalPages}
              </Button>
              {!isLast ? (
                <>
                  <Button
                    disabled={loading}
                    className="btn-circle ml-2"
                    variant="outline-primary"
                    onClick={handleNext}
                  >
                    <ICON_NEXT_ALT />
                  </Button>
                  {!isLast && (
                    <Button
                      disabled={loading}
                      className="btn-circle ml-2"
                      variant="outline-primary"
                      onClick={handleLast}
                    >
                     <ICON_LAST_PAGE />
                    </Button>
                  )}
                </>
              ) : null}
            </div>
          )}
        </div>

        {actuations && actuations.length > 0 ? (
          <React.Fragment>
            <table className="table table-hover table-sm">
              <thead className="thead-light">
                <tr>
                  <th className="align-middle text-center">Fecha</th>
                  <th className="align-middle text-center">Tipo de Escrito</th>
                  <th className="align-middle text-center">Descripción</th>
                  <th className="align-middle text-center">Ver</th>
                </tr>
              </thead>
              <tbody>
                {actuations.map((actuation) => (
                  <tr key={`aId${actuation.id}`}>
                    <td className="align-middle text-center">
                      {actuation.fefi
                        ? moment(actuation.fefi).format("DD/MM/YYYY")
                        : ""}
                    </td>
                    <td className="align-middle text-center">
                      {actuation.tipoEscrito}
                    </td>
                    <td className="align-middle text-center">
                      {actuation.dscr}
                    </td>
                    <td className="align-middle text-center">
                      <Button
                        variant="info"
                        size="sm"
                        onClick={() => handleView(actuation)}
                      >
                        <ICON_SEARCH />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </React.Fragment>
        ) : loading ? (
          <div className="card-body">
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className="col-12 mt-3">
            <div className="alert alert-info">
              No se encontraron actuaciones relacionadas a la audiencia.
            </div>
          </div>
        )}
      </div>

      <ActuationView
        actuation={selectedActuation}
        handleClose={handleClose}
        show={show}
      />
    </div>
  );
};

export default ActuationsList;
